<template>
  <icon-set
    v-if="isLoading === false"
    :icon="icon"
    class="toggle-project-list"
    @click.native.prevent="toggle"
  />
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';

  import IconSet from '@/components/IconSet.vue';

  import Project from '@/domain/project/Project';
  import ProjectListModule from '@/domain/list/ProjectListModule';

  const { mapGetters, mapActions } = createNamespacedHelpers(ProjectListModule.Namespace);

  export default {
    name: 'ToggleProjectList',
    components: {
      IconSet,
    },
    props: {
      project: {
        type: Project,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
        ProjectListModule.Getters.activeList,
      ]),
      isInActiveProjectList() {
        if (!this.activeList) {
          return null;
        }

        return this.activeList.containsProject(this.project.id);
      },
      isLoading() {
        return this.activeList === null;
      },
      icon() {
        return this.isInActiveProjectList ? 'pin-fill' : 'pin';
      },
    },
    methods: {
      ...mapActions({
        toggleProjectList: ProjectListModule.Actions.toggleProjectList,
      }),
      async toggle() {
        if (this.isLoading) {
          return;
        }

        await this.toggleProjectList(this.project.id);

        this.$emit('toggled', this.isInActiveProjectList);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .toggle-project-list {
    cursor: pointer;
  }
</style>
